import styled from "styled-components";

export const BillingWrapper = styled("div")(() => {
  return {
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    "& .heading-row": {
      margin: 0,
      "& h3": {
        marginBlock: 0,
        fontFamily: "Poppins",
        fontWeight: 700,
        fontSize: "1.2rem",
        color: "var(--color-text)",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
      },
    },
    "& .filter-row": {
      alignItems: "center",
      justifyContent: "space-between",
      padding: "var(--cardPadding) 0",
      "@media screen and (max-width: 768px)": {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    "& .filter": {
      display: "flex",
      gap: "calc(var(--flexGap)/2)",
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      alignItems: "end",
      marginBlockEnd: 0,
      "& select, & input": {
        padding: "0.7rem 0.8rem",
        borderRadius: "0.45rem",
        border: "1px solid #d9dee7",
        fontWeight: "400",
        color: "var(--color-text)",
        backgroundColor: "var(--color-neutral)",
        "&:focus": {
          outline: "none",
          border: "1px solid #d9dee7",
        },
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "0.8rem",
        color: "var(--color-primary)",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: "0.45rem",
        display: "inline-block",
      },
      "& fieldset": {
        overflow: "hidden",
      },
    },
    "& .billing-table": {
      overflow: "auto",
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
    },
    "& .billing-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },
    "& td:first-of-type": {
      borderLeft: "none",
    },
    "& .billing-card": {
      background: "var(--color-background)",
      borderRadius: "1rem",
      padding: "var(--cardPadding)",
      marginBottom: "var(--cardMargin)",
      "& .card-title": {
        marginBottom: "var(--cardMargin)",
        "& h3": {
          fontSize: 20,
          fontWeight: 600,
          color: "var(--color-primary)",
        },
      },
    },
    "& .billing-summary": {
      display: "flex",
      justifyContent: "flex-end",
      overflow: "auto",
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
      "& th": {
        width: "50%",
        textAlign: "center",
        fontSize: "20px",
        padding: "10px",
      },
    },
    "& .billing-summary-table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      "& th": {
        color: "var(--color-primary)",
        userSelect: "none",
        backgroundColor: "var(--color-primary-hover)",
        borderBottom: "1px solid #e5e7eb",
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        padding: "0.8rem 1rem",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        fontSize: "0.8rem",
        minWidth: "unset",
        fontWeight: 700,
        textAlign: "left",
      },
      "& th:last-of-type": {
        borderLeft: "1px solid #e5e7eb",
      },
      "& td": {
        textAlign: "left",
        border: "none",
        borderBottom: "1px solid #edf1f6",
        color: "var(--color-text)",
        padding: "0.95rem 1rem",
        minWidth: "unset",
        fontSize: "1rem",
        verticalAlign: "middle",
        position: "relative",
        fontWeight: 700,
      },
      "& td:last-of-type": {
        borderLeft: "1px solid #e5e7eb",
      },
    },
    "@media screen and (max-width: 768px)": {
      "& fieldset": {
        flex: 1,
      },
      "& .filter": {
        width: "100%",
      },
      "& .billing-summary": {
        justifyContent: "flex-start",
        "& .billing-summary-table": {
          width: "100%",
        },
      },
    },
    "& .table-footer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      borderTop: "1px solid #edf1f6",
      backgroundColor: "var(--color-neutral)",
      fontSize: "0.88rem",
      color: "var(--color-text)",
    },
    "& .pagination": {
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
    },
    "& .page-chip": {
      padding: "0.5rem 0.75rem",
      border: "1px solid #d9dee7",
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
      borderRadius: "0.45rem",
      cursor: "pointer",
      fontSize: "0.85rem",
      fontWeight: 600,
      transition: "all 0.2s ease",
      "&:hover:not(:disabled):not(.active)": {
        backgroundColor: "var(--color-primary-hover)",
        borderColor: "var(--color-primary)",
      },
      "&.active": {
        backgroundColor: "var(--color-primary)",
        color: "white",
        borderColor: "var(--color-primary)",
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
  };
});
